// extracted by mini-css-extract-plugin
export default {"container":"HeaderContainerEthicalSavings-module--container--OHhao"};